import { Box, styled } from '@mui/material';

export { IconWrapper } from '../styled';

export const InfoWrapper = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	gap: theme.spacing(1),
}));
